import type { z } from "zod";
import type {
    FeeSourceNotificationsSmsConditionCount} from "./fee-source-notifications-sms-conditions-count";
import {
    feeSourceNotificationsSmsConditionCountZodSchema,
} from "./fee-source-notifications-sms-conditions-count";

type FeeSourceNotificationsSmsCondition =
    FeeSourceNotificationsSmsConditionCount;
const feeSourceNotificationsSmsConditionZodSchema: z.ZodSchema<FeeSourceNotificationsSmsCondition> =
    feeSourceNotificationsSmsConditionCountZodSchema;

export type { FeeSourceNotificationsSmsCondition };
export { feeSourceNotificationsSmsConditionZodSchema };
